import { createContext } from "react";
import { DrawerSelectOptionType } from "../drawer-select.types";

export type DrawerSelectGroupContextType = {
  pushOption: (option: DrawerSelectOptionType) => void;
  removeOption: (option: DrawerSelectOptionType) => void;
  isVisible: (option: DrawerSelectOptionType) => boolean;
  displayCheckbox: boolean;
  disableCheckbox: (option: DrawerSelectOptionType) => boolean;
};

export const DRAWER_SELECT_GROUP_DEFAULT_CONTEXT: DrawerSelectGroupContextType =
  {
    pushOption: () => {},
    removeOption: () => {},
    displayCheckbox: true,
    isVisible: () => true,
    disableCheckbox: () => false,
  };

export const DrawerSelectGroupContext =
  createContext<DrawerSelectGroupContextType>(
    DRAWER_SELECT_GROUP_DEFAULT_CONTEXT,
  );
